<script setup>
import { GlobeEuropeAfricaIcon } from '@heroicons/vue/24/outline';
import { useI18n } from '@/Composables/i18n.js';
import JetDropdown from '@/Components/Dropdown.vue';
import JetDropdownLink from '@/Components/DropdownLink.vue';
import NavigationLabel from './NavigationLabel.vue';
import { utilityTrigger } from './navigationClasses.js';

defineProps({
    locale: {
        type: String,
        default: 'de',
    },
});

const { getTranslationsByPrefix } = useI18n();
</script>

<template>
    <JetDropdown
        class="inline-flex"
        align="right"
        width="32"
    >
        <template #trigger>
            <span class="inline-flex">
                <button
                    type="button"
                    :class="utilityTrigger"
                    :aria-label="$t('components.languageSwitch.switch')"
                >
                    <GlobeEuropeAfricaIcon
                        class="shrink-0 size-6"
                        aria-hidden="true"
                    />

                    <NavigationLabel
                        :title="locale.toUpperCase()"
                        aria-hidden="true"
                    />
                </button>
            </span>
        </template>

        <template #content>
            <div class="block text-xs text-deep-teal-500 purple-theme:text-purple-500 px-3 pt-2 pb-1">
                {{ $t('components.languageSwitch.switch') }}
            </div>

            <div class="font-normal">
                <JetDropdownLink
                    v-for="(language, key) in getTranslationsByPrefix('enums.language')"
                    :key
                    as="a"
                    :href="`/${key !== 'de' ? key : ''}`"
                    :active="key === locale"
                >
                    {{ language }}
                </JetDropdownLink>
            </div>
        </template>
    </JetDropdown>
</template>
